import React from 'react';
import * as C from "../componentsM/index";

const OurVission = () => <>

    <C.Hero title={"OUR VISION"} tagLine={"A Professional And Learning Community With Open Minds To Feel The World."} image={"/hero/9.jpg"} />


    <section className='p-4 md:p-24'>

        <div className='flex flex-col gap-3 '>

            <h1 className='text-xl md:text-4xl font-semibold'>Our Mission</h1>

            <p className='font-semibold'>We prepare our children for the greatest challenge in their life: to make informed decisions. For this purpose as leaders of tomorrow they need to be knowledgeable in various disciplines and skilled in communication and analysis. Only such individuals will be best equipped to engage with people and issues from all over the world.</p>

            <p className='font-semibold'>The International School (TIS) recognises and addresses these needs by fostering a dynamic, nurturing environment for the personal development of each student through an internationally acclaimed balanced curriculum.</p>
        </div>

        <div className='flex flex-col gap-3 my-4'>

            <h1 className='text-xl md:text-4xl font-semibold'>Our Objectives</h1>

            <ul className="list-disc list-inside my-2">
                {[
                    "To be an environment to inspire learners’ to live a sincere and responsible life",
                    "To expose learners to a broad based and balanced curriculum",
                    "To develop learners to analyze data and express their thoughts in clear and coherent manner",
                    "To connect learners with the historical development of humanity with focus on cultures and religions from around the world for developing tolerance and acceptance of differences in thought",
                    "To develop an understanding of learners responsibilities as guardians of their local and global communities",
                    "To adopt teaching, learning and assessment methodologies based on curiosity, imagination, self-knowledge and reflection",
                    "To encourage collaboration of all stake-holders for continued development of our community",
                    "To address the needs for learners with challenges",
                    "To provide a platform for the student voice"
                ]
                    .map(v => <li key={v} className='my-2 font-semibold'>{v}</li>)}
            </ul>



        </div>

    </section>

</>

export default OurVission